var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _vm.hideSubRoute
            ? _c(
                "w-row",
                _vm._l(_vm.roadmaps, function (item) {
                  return _c(
                    "w-col",
                    {
                      key: item.id,
                      staticClass: "mb",
                      attrs: { xs: "12", md: "6" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "roadmap-item" },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(" " + _vm._s(item.Title) + " "),
                          ]),
                          _c("p", {
                            staticClass: "intro",
                            domProps: { innerHTML: _vm._s(item.Intro) },
                          }),
                          _c(
                            "w-link",
                            { attrs: { to: "/support/roadmap/" + item.id } },
                            [_vm._v(" " + _vm._s(_vm.$ct("read-more")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
          _c(
            "w-col",
            {
              class: { hidden: _vm.hideSubRoute },
              attrs: { xs: "12", md: "12" },
            },
            [
              _c(
                "transition",
                { attrs: { name: "fast-fade", mode: "out-in" } },
                [_c("router-view", { key: _vm.$route.path })],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }